import { API } from "./api";
import { toast } from "sonner";

function readToken() {
  try {
    const t = localStorage.getItem("pitboard_session_token");
    if (t) return t;
  } catch { /* noop */ }
  try {
    const m = document.cookie.match(/(?:^|; )pb_tk=([^;]+)/);
    if (m) return decodeURIComponent(m[1]);
  } catch { /* noop */ }
  return null;
}

/**
 * Ouvre un PDF dans un nouvel onglet — compatible iOS Safari, Edge, Android, Desktop.
 *
 * STRATÉGIE : URL directe avec ?token=<token> en query string + window.open synchrone.
 */
export function downloadPdf(path) {
  const token = readToken();
  if (!token) {
    toast.error("Session expirée — reconnectez-vous");
    return;
  }
  const sep = path.includes("?") ? "&" : "?";
  const url = `${API}${path}${sep}token=${encodeURIComponent(token)}`;
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win || win.closed || typeof win.closed === "undefined") {
    toast.info("Popups bloquées — autorisez les popups pour ce site");
  }
}
